import { useCallback, useEffect } from 'react';

/**
 * It handles the database iframe resize message and passes it to the window with smartlink.
 */
export const usePostMessageHandler = (iframeRef: React.RefObject<HTMLIFrameElement>): void => {
	const messageCallback = useCallback(
		(event: MessageEvent) => {
			const isFromExpectedIframe =
				iframeRef.current && event.source === iframeRef.current.contentWindow;
			const isStringData = typeof event.data === 'string';

			if (isFromExpectedIframe && isStringData) {
				try {
					window.parent.postMessage(event.data, '*');
				} catch (e) {}
			}
		},
		[iframeRef],
	);

	useEffect(() => {
		window.addEventListener('message', messageCallback);

		return () => {
			window.removeEventListener('message', messageCallback);
		};
	}, [messageCallback]);
};
